import { MODULE_I18_PREFIX } from '../config/i18.luci';

export const ACH_MAIN_TABS_I18_PREFIX =
  `${MODULE_I18_PREFIX}.ach.mainTabs` as const;
export const ACH_TABS_I18_PREFIX = `${MODULE_I18_PREFIX}.ach.tabs` as const;
export const ACH_TABLE_I18_PREFIX = `${MODULE_I18_PREFIX}.ach.table` as const;
export const ACH_MAIN_TABS = {
  NEW: 'new'
} as const;
